import bus from '@/libs/bus'
import { onDeactivated, getCurrentInstance } from '@vue/composition-api'
export default function useToasts () {
    const vm = getCurrentInstance().proxy
    const makeToast = (variant) => {
        return function ({ title, content }) {
            vm.$bvToast.toast(content, {
                title: title || `Variant ${variant || 'default'}`,
                variant,
                solid: true
            })
        }
    }
    const successToast = makeToast('success')
    const warningToast = makeToast('warning')
    const errorToast = makeToast('danger')

    bus.$on('request:error', errorToast)
    bus.$on('request:warning', warningToast)
    bus.$on('request:success', successToast)

    onDeactivated(() => {
        bus.$off('request:error', errorToast)
        bus.$off('request:warning', warningToast)
        bus.$off('request:success', successToast)
    })
}
